export interface PortalSearchResult {
  ok: boolean
  codeKey: string | null
  error?: string
}

export async function findPortalNamekey(
  portalCodeKey: string,
  nameKey: string,
): Promise<PortalSearchResult> {
  const params = new URLSearchParams({
    portal_code_key: portalCodeKey,
    name_key: nameKey,
  })
  const response = await fetch(`/api/portal_namekey?${params}`, {
    method: 'GET',
    credentials: 'same-origin',
  })
  const data = await response.json().catch(() => null) as PortalSearchResult | null
  if (!response.ok || !data) {
    return { ok: false, codeKey: null, error: data?.error || 'err_search' }
  }
  return {
    ok: data.ok === true,
    codeKey: typeof data.codeKey === 'string' && data.codeKey ? data.codeKey : null,
    error: data.error,
  }
}
